import * as React from 'react';
import BuildingBlockHeader from './BuildingBlockHeader';
import BuildingBlockMemoryItemContainer from './BuildingBlockMemoryItemContainer';
import {DiagramInstruction} from '../../../stores/OdtExportStore';
import {NumericFormatter} from '../../../utility/FormatValueUtils';
import {Channel} from '../../../types/Channel';
import {stylesheet} from 'typestyle';
import TablePreview from './TablePreview';
import {DataKey} from '../../../stores/GeneralSelectorTableStore';
import ColumnPicker from '../ColumnPicker';
import {TableLimitPicker} from './TableLimitPicker';
import {
    BuildingBlockType,
    MergedBuildingBlockInstructions,
    NamedDateRangeWithPreviewDateRange,
    ReportBuildingBlock,
    TableBuildingBlock,
} from '../../types/Report';
import {DateIdBundle} from '../../stores/ReportEditorStore';

interface TableBuildingBlockDroppableProps {
    targetCurrency?: string;
    buildingBlock: TableBuildingBlock;
    removeBuildingBlock: (idBlock: string) => void;
    removeDiagramTraitFromBuildingBlock: (idBuildingBlock: string, diagramTrait: DiagramInstruction) => void;
    getMergedBuildingBlockInstructions: (buildingBlock: ReportBuildingBlock) => MergedBuildingBlockInstructions;
    removeTableTraitFromBuildingBlock: (idBuildingBlock: string, traitKey: string, traitToRemove: any) => void;
    moneyFormatToTargetCurrency: (fractions?: number) => NumericFormatter;
    getFullChannelForChannelName: (channelName: string) => Channel;
    updateLineLimitForTableBlock: (idTableBuildingBlock: string, lineLimit: number) => void;
    updateTableColumnVisibility: (idTableBuildingBlock: string, dataKey: DataKey, visibility: boolean) => void;
    changeBuildingBlockType: (idBuildingBlock: string, newBlockType: BuildingBlockType) => void;
    namedDateRangePackage: {
        namedDateRanges: NamedDateRangeWithPreviewDateRange[];
        selectedIdNamedDateRange: string;
        changeSelectedNamedDateRange: (idBuildingBlock: string, dateIdBundle: DateIdBundle) => void;
    };
    selectedNamedDateRange?: NamedDateRangeWithPreviewDateRange;
    traitChecks: {
        hasToManyChannels: (reportBlocks: ReportBuildingBlock[]) => boolean;
        hasToManySearches: (reportBlocks: ReportBuildingBlock[]) => boolean;
        hasToManySortings: (reportBlocks: ReportBuildingBlock[]) => boolean;
        reportBuildingBlocksAreEmpty: (buildingBlocks: ReportBuildingBlock[]) => boolean;
        hasSearchProductMixedBuildingBlocks: (reportBlocks: ReportBuildingBlock[]) => boolean;
    };
    removeDiagramCompareTraitFromBuildingBlock: (idBuildingBlock: string) => void;
}

export default class TableBuildingBlockDroppable extends React.Component<TableBuildingBlockDroppableProps> {
    private renderTablePreview(mergedTableData: MergedBuildingBlockInstructions) {
        const {channels, sortings, searches, activeViews} = mergedTableData.tableInstruction
            ? mergedTableData.tableInstruction
            : {activeViews: [], channels: [], sortings: [], searches: []};

        if (channels.length === 1 && sortings.length <= 1 && searches.length <= 1 && activeViews.length === 1 && this.props.selectedNamedDateRange) {
            return (
                <div className={tableBlockCss.tablePreviewContainer}>
                    <div className={tableBlockCss.limitColumnPickerContainer}>
                        <ColumnPicker
                            idParentBuildingBlock={this.props.buildingBlock.id}
                            updateTableColumnVisibility={this.props.updateTableColumnVisibility}
                            columns={this.props.buildingBlock.columns}
                        />
                        <TableLimitPicker
                            lineLimitChanged={(newLimit) => this.props.updateLineLimitForTableBlock(this.props.buildingBlock.id, newLimit)}
                            lineLimit={this.props.buildingBlock.lineLimit}
                        />
                    </div>
                    <TablePreview
                        targetCurrency={this.props.targetCurrency}
                        previewModeEnabled={false}
                        columns={this.props.buildingBlock.columns}
                        lineLimit={this.props.buildingBlock.lineLimit}
                        dateRange={this.props.selectedNamedDateRange.previewDateRange}
                        mergedBuildingBlockInstructions={mergedTableData}
                        moneyFormatToTargetCurrency={this.props.moneyFormatToTargetCurrency}
                        getFullChannelForChannelName={this.props.getFullChannelForChannelName}
                    />
                </div>
            );
        }
        return null;
    }

    public render() {
        const {removeBuildingBlock, buildingBlock, traitChecks, removeDiagramCompareTraitFromBuildingBlock} = this.props;
        const mergedBuildingBlockInstructions = this.props.getMergedBuildingBlockInstructions(buildingBlock);

        return (
            <div>
                <BuildingBlockHeader
                    namedDateRangePackage={this.props.namedDateRangePackage}
                    idBuildingBlock={this.props.buildingBlock.id}
                    changeBuildingBlockType={this.props.changeBuildingBlockType}
                    removeBuildingBlock={() => removeBuildingBlock(buildingBlock.id)}
                    buildingBlockType={this.props.buildingBlock.blockType}
                />
                {this.renderTablePreview(mergedBuildingBlockInstructions)}
                <BuildingBlockMemoryItemContainer
                    traitChecks={traitChecks}
                    idParentBlock={buildingBlock.id}
                    removeDiagramTraitFromBuildingBlock={this.props.removeDiagramTraitFromBuildingBlock}
                    removeTableTraitFromBuildingBlock={this.props.removeTableTraitFromBuildingBlock}
                    buildingBlock={this.props.buildingBlock}
                    mergedBuildingBlockInstructions={mergedBuildingBlockInstructions}
                    removeDiagramCompareTraitFromBuildingBlock={removeDiagramCompareTraitFromBuildingBlock}
                />
            </div>
        );
    }
}

const tableBlockCss = stylesheet({
    tablePreviewContainer: {
        position: 'relative',
        minHeight: 300,
    },
    limitColumnPickerContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
});



// WEBPACK FOOTER //
// ./src/report/views/PaperSheetBlocks/TableBuildingBlockDroppable.tsx